import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useAddMemberDialogStyles = makeStyles({
  chipList: {
    display: "flex",
    flexWrap: "wrap",
    gap: designTokens.spacing[2],
  },
  chipAvatar: {
    width: "20px",
    height: "20px",
  },
});
